import React from "react";
import "./WeatherDetails.css";

const WeatherDetails = ({ data }) => {
  const {
    main: { feels_like, humidity, pressure },
    wind: { speed, deg },
    clouds: { all: cloudiness },
    visibility,
  } = data;

  const details = [
    {
      icon: "🌡️",
      label: "Feels Like",
      value: `${Math.round(feels_like)}°C`,
    },
    {
      icon: "💧",
      label: "Humidity",
      value: `${humidity}%`,
      progress: humidity,
    },
    {
      icon: "💨",
      label: "Wind Speed",
      value: `${speed} m/s`,
    },
    {
      icon: "🧭",
      label: "Wind Direction",
      value: `${deg}°`,
    },
    {
      icon: "📊",
      label: "Pressure",
      value: `${pressure} hPa`,
    },
    {
      icon: "👁️",
      label: "Visibility",
      value: `${(visibility / 1000).toFixed(1)} km`,
    },
    {
      icon: "☁️",
      label: "Cloudiness",
      value: `${cloudiness}%`,
      progress: cloudiness,
    },
  ];

  return (
    <div className="weather-details glass-card">
      <h3>📊 Weather Details</h3>
      <div className="details-grid">
        {details.map((detail, index) => (
          <div key={index} className="detail-card">
            <div className="detail-header">
              <span className="detail-icon">{detail.icon}</span>
              <span className="detail-label">{detail.label}</span>
            </div>
            <span className="detail-value">{detail.value}</span>
            {detail.progress !== undefined && (
              <div className="detail-progress">
                <div
                  className="detail-progress-bar"
                  style={{ width: `${detail.progress}%` }}
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default WeatherDetails;
